import { render } from "./Third.vue?vue&type=template&id=65e59cda&scoped=true"
import script from "./Third.vue?vue&type=script&lang=js"
export * from "./Third.vue?vue&type=script&lang=js"

import "./Third.vue?vue&type=style&index=0&id=65e59cda&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\dragoncrew\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e59cda"]])

export default __exports__